import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { TrendingUp, Shield, BarChart3, Target, DollarSign, Lightbulb } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function InvestmentStrategies() {
  const strategies = [{
    icon: TrendingUp,
    title: "Análisis Técnico \"Promedio Móviles\"",
    description: "Domina patrones de velas, indicadores y estrategias de entrada/salida para identificar oportunidades de inversión en tiempo real."
  }, {
    icon: BarChart3,
    title: "Análisis Fundamental",
    description: "Aprende a evaluar empresas mediante estados financieros, ratios clave y análisis de industria para inversiones a largo plazo."
  }, {
    icon: Shield,
    title: "Gestión de Riesgo",
    description: "Implementa estrategias de protección de capital, diversificación de portafolio y establecimiento de límites de pérdida."
  }, {
    icon: Target,
    title: "Trading de Posición",
    description: "Desarrolla estrategias para mantener posiciones durante semanas o meses, aprovechando tendencias de mediano plazo."
  }, {
    icon: DollarSign,
    title: "Inversión en Dividendos",
    description: "Construye un portafolio generador de ingresos pasivos mediante acciones de empresas con historial sólido de dividendos."
  }, {
    icon: Lightbulb,
    title: "Estrategias de Volatilidad",
    description: "Capitaliza en movimientos del mercado usando contratos de opciones y estrategias avanzadas para diferentes condiciones de volatilidad."
  }];
  return <section className="bg-background-dark text-foreground-dark py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4 text-foreground-dark">
            Nuestras Estrategias de Inversión
          </h2>
          <p className="text-lg text-foreground-dark/80 max-w-3xl mx-auto">
            En Zafiro Investments enseñamos estrategias comprobadas que te permitirán operar con confianza en el mercado de valores estadounidense, desde análisis técnico hasta inversión en dividendos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {strategies.map((strategy, i) => {
          const Icon = strategy.icon;
          return <Card key={i} data-index={i} className="bg-white border-border hover-lift animate-fade-in-up" style={{
            animationDelay: `${i * 100}ms`
          }}>
                <CardHeader>
                  <div className="flex items-center gap-3 mb-2">
                    <div className="flex items-center justify-center size-10 rounded-md bg-primary/10">
                      <Icon className="size-5 text-primary" />
                    </div>
                  </div>
                  <CardTitle className="text-xl text-primary">
                    {strategy.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed">
                    {strategy.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="text-center animate-fade-in-up" style={{
        animationDelay: '600ms'
      }}>
          <Link to="/CursosPage">
            <Button size="lg" className="btn-primary shadow-medium">
              Explorar Nuestros Cursos
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}